import React from 'react';
import { Briefcase, Calendar, MapPin } from 'lucide-react';
import { experience } from '../data/mock';

const ExperienceSection = () => {
  return (
    <section id="experience" className="py-24 bg-zinc-950">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-cyan-400 font-mono text-sm mb-2">// EXPERIENCE</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white">Career Journey</h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-0 md:left-8 top-0 bottom-0 w-px bg-zinc-800" />

          {/* Experience Items */}
          <div className="space-y-12">
            {experience.map((exp, index) => (
              <div
                key={exp.id}
                className="relative pl-8 md:pl-20"
              >
                {/* Timeline Dot */}
                <div className="absolute left-0 md:left-8 w-4 h-4 bg-cyan-500 rounded-full border-4 border-zinc-950 -translate-x-1/2 z-10" />

                {/* Content Card */}
                <div className="p-6 bg-zinc-900/50 border border-zinc-800 rounded-2xl hover:border-zinc-700 transition-all group">
                  {/* Header */}
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
                    <div>
                      <h3 className="text-xl font-semibold text-white group-hover:text-cyan-400 transition-colors">
                        {exp.position}
                      </h3>
                      {exp.subtitle && (
                        <p className="text-cyan-400 text-sm">{exp.subtitle}</p>
                      )}
                      <div className="flex items-center gap-2 text-zinc-400 mt-1">
                        <Briefcase className="w-4 h-4" />
                        <span>{exp.company}</span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 text-sm">
                      <div className="flex items-center gap-2 text-zinc-500">
                        <Calendar className="w-4 h-4" />
                        <span>{exp.period}</span>
                      </div>
                      {exp.location && (
                        <div className="flex items-center gap-2 text-zinc-500">
                          <MapPin className="w-4 h-4" />
                          <span>{exp.location}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-zinc-500 text-sm mb-4">
                    {exp.description}
                  </p>

                  {/* Achievements */}
                  <ul className="space-y-2">
                    {exp.achievements.map((achievement, achIndex) => (
                      <li
                        key={achIndex}
                        className="flex items-start gap-2 text-sm text-zinc-400"
                      >
                        <span className="text-cyan-500 mt-1">•</span>
                        <span>{achievement}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
